export const equivalentDealersToBranches = {
  1: 534,
  2: 37,
  3: 38,
  4: 40,
  5: 34,
  6: 35,
  7: 36,
  8: 39,
  9: 526,
  10: 700,
  11: 2069,
  12: 2284,
  13: 2285,
  14: 2297
};